import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from 'src/app/shared/services/common.service';
import { InvoiceViewService } from '../invoice-view/invoice-view.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-view-document',
  templateUrl: './view-document.component.html',
  styleUrls: ['./view-document.component.scss']
})
export class ViewDocumentComponent implements OnInit {

  isRider: boolean;
  selectedValue;
  status: string;
  showSuccess = false;
  showError = false;
  isLoading = false;
  tollDisable: boolean;
  permitDisable: boolean;
  parkingDisable: boolean;
  othersDisable: boolean;
  tollConfig: any;
  parkingConfig: any;
  permitConfig: any;
  othersConfig: any;
  vendorInvoiceConfig: any;
  showReasonError: boolean;
  showApprovePopup = false;
  reasonText: string;
  maxLimit = 200;
  isSubmitReasonClicked: boolean;
  approveReasonForAmountMismatch: boolean;

  constructor(private router: Router,
              private commonService: CommonService,
              private activatedRoute: ActivatedRoute,
              private invoiceViewService: InvoiceViewService,
              private authService: AuthService) {
                const state = this.router.getCurrentNavigation().extras.state;
                this.invoiceStatus = state.invoiceStatus;
                this.approveReasonForAmountMismatch = Number(state.vendorBillAmount) != Number(state.paymentAmount);
                this.isRider = !!state.isRider;
                if (this.invoiceStatus === 'PENDING' || this.invoiceStatus === 'NOT_REQUIRED_FOR_NOW'){
                  this.pendingInvoice = true;
                }
                else{
                  this.pendingInvoice = false;
                }

                this.parkingDisable = true;
                this.permitDisable = true;
                this.othersDisable = true;
                this.tollDisable = true;
            }

  public config: any = {};
  showApprovedToast = false;
  showRejectedPopup = false;
  showInvoiceFiles = false;

  previewUrl;
  rejectReason;
  showFileUrl;
  noFile;
  showPreviewUrl;
  fileUrl;
  invoiceStatus;
  uploadedDocumentList;
  pendingInvoice;
  systemInvoice: any = [];
  showPdf = false;

  tollUploadedFiles: any = [];
  parkingUploadedFiles: any = [];
  permitUploadedFiles: any = [];
  invoiceUploadedFiles: any = [];
  othersUploadedFiles: any = [];
  showSuccessErrorAction;
  toggleLoadingOnViewInvoice;
  rejectReasonConfig;
  bookingId;
  private destroy$ = new Subject();

  ngOnInit() {
    this.commonService.fetchMiscConfig().subscribe(response => {
      if (response && response['invoiceRejectReason']) {
        this.rejectReasonConfig = response['invoiceRejectReason'];
      }
    });
    this.activatedRoute.queryParams.subscribe(params => {
      this.bookingId = params.bookingId;
    });
    this.commonService.fetchConfig().subscribe((response: any) => {
      const configuration = this.commonService.getConfigForElementKey(response, 'Edit Booking Parameters For Billing');
      this.config = this.commonService.getConfigForElementKey(configuration, 'Adjustments');
      this.tollConfig = this.commonService.getConfigForElementKey(this.config, 'toll');
      this.parkingConfig = this.commonService.getConfigForElementKey(this.config, 'parking');
      this.permitConfig = this.commonService.getConfigForElementKey(this.config, 'permit');
      this.othersConfig = this.commonService.getConfigForElementKey(this.config, 'otherCost');
      this.vendorInvoiceConfig = this.commonService.getConfigForElementKey(this.config, 'vendorBillAmount');
      this.getAllDocuments();
    });
  }

  getAllDocuments() {
    const query = {
      bookingId: this.bookingId,
      clientId: this.authService.client.client,
      buid: this.authService.user.buId,
    };
    this.invoiceViewService.getAllDocumentList(query).
    pipe(takeUntil(this.destroy$))
    .subscribe((response) => {
      this.uploadedDocumentList = response ? response.uploadedFiles : null;
      if (this.uploadedDocumentList) { this.extractUploadedFilesCategory(); }
    });

  }

  submitForApproval(reasonControl) {
    this.isSubmitReasonClicked = true;
    if (!reasonControl.errors) {
      this.showApprovePopup = false;
      this.reasonText = "";
      this.isRider ? this.approveRejectRiderInvoice('APPROVED') : this.approveInvoice();
    }
  }
  getColor(status) {
    switch (status) {
      case 'APPROVED':
        return '#3cae4c';
      case 'PENDING':
        return 'blue';
      case 'REJECTED':
        return '#ff6468';
    }
  }

  rejectInvoice() {
    // this.pendingInvoice = false;
    this.showRejectedPopup = true;
  }

  confirmRejection(rejectReason) {
    if (this.rejectReasonConfig === 'true'){
      if (rejectReason){
        this.confirmRejectInvoice(rejectReason);
    }
    else{
      this.showReasonError = true;
    }
  }
  else{
    this.confirmRejectInvoice(rejectReason);
  }
 }

  confirmRejectInvoice(rejectReason){
    this.rejectReason = rejectReason;
    this.status = "REJECTED";
    if (this.isRider) {
      this.approveRejectRiderInvoice("REJECTED");
    } else {
      const postData = [
        {
          approvalStatus: 'REJECTED',
          bookingID: this.bookingId,
          modifierBuid: this.authService.user.buId,
          modifierGuid: this.authService.user.employeeGuid,
          reasonText: this.rejectReason
        }
  ];
      this.isLoading = true;

      this.invoiceViewService.updateInvoiceStatus(postData).subscribe((response) => {
    this.isLoading = false;
    this.showRejectedPopup = false;
    this.showApprovedToast = true;
    this.showSuccess = true;
    this.isLoading = false;
    // this.pendingInvoice = false;
    const navigationExtras: NavigationExtras = {
     state: {
       showApprovedToast: this.showApprovedToast
     },
   };
    setTimeout(() =>  this.router.navigate(['/invoicing'], navigationExtras), 1000);
  }, () => {
   this.isLoading = false;
   this.showError = true;
  });
  }
}

  selectFile(fileObj){
   this.displayPdf(fileObj);
  }

  approveRejectRiderInvoice(status) {
    this.status = status;
    this.isLoading = true;
    let postData;
    if (status === 'APPROVED') {
      postData = this.setDataForRiderInvoice(status);
    } else if (status === 'REJECTED') {
      postData = this.setDataForRiderInvoice(status, this.rejectReason);
    }

    this.invoiceViewService.updateRiderInvoice(postData).
    subscribe((response) => {
      this.showSuccess = true;
      this.isLoading = false;
      setTimeout(() =>  this.router.navigate(['/bookings']), 1000);
    },
    (error) => {
      this.isLoading = false;
      // error block
      this.showError = true;
    });
  }
  setDataForRiderInvoice(status, reasonText?: string) {
    return {
      bookingId: this.bookingId,
      reasonText : reasonText || '',
      modifierBuid: this.authService.user.buId,
      modifierGuid: this.authService.user.employeeGuid,
      status
    };
  }

  approveInvoice() {
    this.isLoading = true;
    this.status = "APPROVED";
    const postData = [
      {
        approvalStatus: 'APPROVED',
        bookingID: this.bookingId,
        modifierBuid: this.authService.user.buId,
        modifierGuid: this.authService.user.employeeGuid
      }
    ];
    this.invoiceViewService.updateInvoiceStatus(postData).subscribe((response) => {
     this.isLoading = false;
     this.showSuccess = true;
      // this.pendingInvoice = false;
     this.showApprovedToast = true;
     const navigationExtras: NavigationExtras = {
        state: {
          showApprovedToast: this.showApprovedToast
        },
      };
     setTimeout(() =>  this.router.navigate(['/invoicing'], navigationExtras), 1000);
    }, () => {
      this.isLoading = false;
      this.showError = true;
    });
  }

  dismissPopup(){
    this.showRejectedPopup = false;
  }

  openSystemInvoice(){
    if (this.systemInvoice.length !== 0){
      this.showPreviewUrl = true;
      this.previewUrl = '';
      this.previewUrl = this.systemInvoice[0]['fileUrl'];
    }
    else{
      this.showPreviewUrl = false;
    }
    const element = document.getElementById("vendor");
    if (element) {
      element.classList.remove("activeButton");
      element.classList.add("button");
    }
    const element1 = document.getElementById("system");
    element1.classList.add("activeButton");
    element1.classList.remove("button");
  }

  extractUploadedFilesCategory() {
    this.uploadedDocumentList.forEach((list) => {
      if (list.documentType === 'TOLL') {
        this.tollUploadedFiles.push(list);
      } else if (list.documentType === 'PARKING') {
        this.parkingUploadedFiles.push(list);
      } else if (list.documentType === 'PERMIT') {
        this.permitUploadedFiles.push(list);
      } else if (list.documentType === 'INVOICE') {
        this.invoiceUploadedFiles.push(list);
      } else if (list.documentType === 'OTHERS') {
        this.othersUploadedFiles.push(list);
      } else if (list.documentType === 'SYSTEM_INVOICE') {
        this.systemInvoice.push(list);
      }
    });
    this.showDropdownFiles();
    this.openSystemInvoice();
    if (this.invoiceUploadedFiles.length !== 0){
      this.showInvoiceFiles  = true;
    }
  }

  // showSystemVendorInvoice(){
  //   if(this.systemInvoice.length !== 0){
  //     this.openSystemInvoice();
  //   }
  //   if(this.invoiceUploadedFiles.length !== 0){
  //     this.showInvoiceFiles  = true;
  //     // this.getInvoiceUploaded();
  //     var element = document.getElementById("system");
  //     element.classList.remove("activeButton");
  //     element.classList.add("button");
  //     var element1 = document.getElementById("vendor");
  //     element1.classList.add("activeButton");
  //     element1.classList.remove("button");
  //   }
  //   else{
  //     this.showPreviewUrl = false;
  //   }
  // }

  showDropdownFiles(){
      // dropdown disable if no files
      let fileObj;
      if (this.tollUploadedFiles.length !== 0){
        this.tollDisable = false;
        fileObj = this.tollUploadedFiles[0];
      }
      if (this.permitUploadedFiles.length !== 0){
        this.permitDisable = false;
        fileObj = this.permitUploadedFiles[0];
      }
      if (this.parkingUploadedFiles.length !== 0){
        this.parkingDisable = false;
        fileObj = this.parkingUploadedFiles[0];
      }
      if (this.othersUploadedFiles.length !== 0){
        this.othersDisable = false;
        fileObj = this.othersUploadedFiles[0];
      }
      this.displayPdf(fileObj);
  }
  displayPdf(fileObj){
    if (fileObj){
      this.fileUrl = '';
      if (fileObj["fileName"].slice(-3) === "pdf"){
        this.showFileUrl = false;
        this.showPdf = true;
        this.fileUrl = fileObj["fileUrl"];
      }
      else{
        this.showFileUrl = true;
        this.fileUrl = fileObj["fileUrl"];
      }
    }
    else{
      this.noFile = true;
    }
  }

  dismissToast(){
    this.showApprovedToast = false;
  }

  closeModal() {
    this.showApprovePopup = false;
    this.reasonText = "";
  }


  getInvoiceUploaded(){
    if (this.invoiceUploadedFiles.length !== 0){
      this.showPreviewUrl = true;
      this.previewUrl = '';
      this.previewUrl = this.invoiceUploadedFiles[0]["fileUrl"];
    }
    else{
      this.showPreviewUrl = false;
    }
    const element = document.getElementById("system");
    element.classList.remove("activeButton");
    element.classList.add("button");
    const element1 = document.getElementById("vendor");
    element1.classList.add("activeButton");
    element1.classList.remove("button");
  }

  goBack(){
    if (this.isRider) {
      this.router.navigate(['/bookings']);
    } else {
      this.router.navigate(['/invoicing']);
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeToast() {
    this.showSuccess = false;
    this.showError = false;
  }
}
